<template>
  <section id="hero" class="hero">
    <div class="carousel">
      <Transition name="hero-fade">
        <img
          :key="activeImage.id"
          :src="activeImage.src"
          :srcset="activeImage.srcSet"
          sizes="100vw"
          alt=""
          aria-hidden="true"
          decoding="async"
          fetchpriority="high"
        />
      </Transition>
    </div>
    <div class="logo-container">
      <img src="@/assets/branding/logo-white.svg" alt="Logo" class="logo" />
    </div>
    <svg style="width: 0; height: 0;">
      <filter id="svg-shadow" x="-50%" y="-50%" width="200%" height="200%">
        <feDropShadow dx="0" dy="0" stdDeviation="8" flood-color="rgba(0,0,0,0.9)" />
      </filter>
    </svg>
  </section>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { heroImages } from '@/data/media';

const currentImage = ref(Math.floor(Math.random() * heroImages.length));
const activeImage = computed(() => heroImages[currentImage.value]);
let interval = null;

const cycleImages = () => {
  currentImage.value = (currentImage.value + 1) % heroImages.length;
};

onMounted(() => {
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    interval = window.setInterval(cycleImages, 10000);
  }
});

onBeforeUnmount(() => {
  window.clearInterval(interval);
});
</script>

<style scoped>
.hero {
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  position: relative;
  width: 100%;
  height: clamp(470px, 70vh, 720px);
  overflow: hidden;
  background: var(--secondary-color);
}

.carousel {
  width: 100%;
  height: 100%;
  position: relative;
}

.carousel::after {
  content: '';
  position: absolute;
  inset: 0;
  z-index: 1;
  background:
    linear-gradient(90deg, rgba(19, 29, 41, 0.38), rgba(19, 29, 41, 0.04) 52%, rgba(19, 29, 41, 0.22)),
    linear-gradient(0deg, rgba(19, 29, 41, 0.3), transparent 48%);
}

.carousel img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 0 23%;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.hero-fade-enter-active,
.hero-fade-leave-active {
  transition: opacity 1s ease-in-out;
}

.hero-fade-enter-from,
.hero-fade-leave-to {
  opacity: 0;
}

.logo-container {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 2;
  width: 100%;
  padding: 0 24px;
  text-align: center;
  transform: translate(-50%, -50%);
}

.logo {
  width: min(820px, 76vw);
  height: auto;
  filter: drop-shadow(0 8px 24px rgba(0, 0, 0, 0.48));
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

@media (max-width: 767px) {
  .hero {
    height: clamp(430px, 68vh, 620px);
  }

  .carousel img {
    object-position: center;
  }

  .logo {
    width: min(430px, 90vw);
  }

  .logo-container {
    top: 72%;
  }

}
</style>
